import features from 'Cloud/Application/Features';
import { extInfo } from 'lib/extInfo';

export default function() {
    const overriddenExtensions = features.getFeature('override-ext-info');

    if (overriddenExtensions) {
        // в ext.js на сервере выполняется аналогичное действие
        Object.keys(overriddenExtensions).forEach(function (ext) {
            extInfo.set(ext, overriddenExtensions[ext]);
        });
    }
};
